import { Loading, PermissionDenied } from '@/components';
import type { FC, PropsWithChildren } from 'react';

import { useMe } from '../_hooks/me';
import type { AbilityGuardProps } from '../_types/authentication';

export const TemplateAbilityGuard: FC<PropsWithChildren<AbilityGuardProps>> = ({
  showDenied,
  children,
}) => {
  const me = useMe();

  if (me.isPending) {
    return <Loading />;
  }

  return me.data?.role.templateAbility ? (
    <>{children}</>
  ) : showDenied ? (
    <PermissionDenied />
  ) : null;
};
